import { render, staticRenderFns } from "./Renderer.vue?vue&type=template&id=7035642a"
import script from "./Renderer.vue?vue&type=script&lang=js"
export * from "./Renderer.vue?vue&type=script&lang=js"
import style0 from "./Renderer.vue?vue&type=style&index=0&id=7035642a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports